import ScheduledTasksList from "../Components/ScheduledTasks/ScheduledTasksList";

const ScheduledTasksListPage = () => {
  return <ScheduledTasksList />;
};

export default ScheduledTasksListPage;
